import { render } from "./LoginHistory.vue?vue&type=template&id=08a3f14b&scoped=true"
import script from "./LoginHistory.vue?vue&type=script&lang=js"
export * from "./LoginHistory.vue?vue&type=script&lang=js"

import "./LoginHistory.vue?vue&type=style&index=0&id=08a3f14b&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a3f14b"]])

export default __exports__